import { useEffect, useState } from 'react';
import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { PublicUserWithAnniversary } from '../../../commonTypes/user.types';

const useHttpGetAnniversariesOnMount = (from: string, to: string) => {
    const userApi: UserApi = useContainer(UserApi);
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState<PublicUserWithAnniversary[]>([]);

    useEffect(() => {
        const { exec, abort } = userApi.getAnniversaries({
            query: { from, to },
            onSuccess: res => setData(res.body),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, []);
    return { isReady, data };
};

export default useHttpGetAnniversariesOnMount;
